<template>
  <div class="group-manage conmon-top" style="height: 100%;">
    <el-container style="overflow-x: hidden;">
      <!--左侧分组-->
      <el-aside class="left-aside-type" width="220px">
        <div class="group-search">
          <el-input
            placeholder="请输入内容"
            v-model.trim="groupNameTmp"
            @keyup.enter.native="searchGroupType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="searchGroupType"></i>
          </el-input>
        </div>
        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups" :key="index" @click="chooseGroupType(index, item)">
            <div class="menu-btn"  v-if="item.name !== '全部'">
              <i @click="editGroupTypeItem(item)" class="el-icon-edit" style="margin-right: 0"></i>
              <i @click="deleteGroupTypeItem(item)" class="el-icon-close" style="margin-right: 0"></i>
            </div>
            <span class="menu-title" :title="item.name">{{ item.name }}</span>
          </el-menu-item>
          <div class="add-group-btn" @click="addGroup">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: 100%; overflow-x: hidden;">
        <div class="base-input ovf-hd" style="margin-bottom: 10px; overflow-x: hidden;">
          <el-row class="search-title" v-if="!isHigher">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
               <el-button class="fold-button" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
                <el-button class="fold-button" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
                <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide" v-if="!isHigher">
            <el-col :span="24" class="text-align-left">
              <span style="margin-left: 50px">输入搜索：</span>
              <el-input placeholder="群组名称" clearable @keyup.enter.native="searchLoad" v-model.trim="search.name" ></el-input>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row class="search-content" style="min-height:210px;height:auto;line-height: 0" v-show="isHigher">
            <div style="height: 50px;background: #fff;line-height: 50px;text-align: left;border-bottom: 1px solid #E7E7E7;color: #333">
              <i class="el-icon-document" style="color: #333;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
              <span style="padding-left: 0;color: #666" v-if="createGroupType === 2">创建静态群组</span>
              <span style="padding-left: 0;color: #666" v-if="createGroupType === 1">创建动态群组</span>
              <div class="cancelCreate" @click="cancelCreate">
                <i class="el-icon-close" title="取消创建"></i>
              </div>
            </div>
            <div style="text-align: left;padding: 20px 0" class="hei-ser">
              <span style="margin-left: 20px">群组名称：</span>
              <el-input class="common-search-formtype" placeholder="群组名称" v-model="newGroupName"></el-input>
              <el-button type="primary" class="add-btn" style="margin-right: 32px" @click="preView">预览</el-button>
              <el-button type="primary" :disabled="isDisabled" :class="isDisabled ? 'disabled' : 'add-btn'" class="add-btn" style="margin-right: 10px" @click="saveQuery">保存</el-button>
            </div>
            <div style="text-align: left;padding-bottom: 10px">
              <span style="margin-left: 10px">群组条件：</span>
            </div>
            <higher-search class="common-search-formtype customer-manage-higher-search group-item-style" :forSonTerms="forSonTerms" @change="getAllTerms"></higher-search>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span v-if="showCustomer === true">群组列表</span>
            <span v-if="showCustomer === false">客户列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right">
            <span style="margin-left: 20px">移到分组：</span>
            <el-select class="common-search-formtype" style="margin-right: 13px" v-model="group_id" @change="confirmChooseGroupType" :disabled="checkAll" placeholder="请选择目标分组">
              <el-option
                v-for="item in queryGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <!--<div class="add-btn">导入客户</div>-->
            <el-button type="primary" class="add-btn btn-right" style="float: right;" @click="reloadCustomerNum">刷新人数</el-button>
            <div class="fold-button-content">
              <el-button type="primary" class="add-btn list-btn-margin" @click="createStaticsGroup" >创建静态群组</el-button>
              <el-button type="primary" class="add-btn list-btn-margin" @click="createIntelligentGroup" style="margin-left:0">创建动态群组</el-button>
            </div>
            <div class="dropdown-btn-content">
              <el-dropdown>
                <span class="el-dropdown-link">
                  创建群组
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span @click="createStaticsGroup" name="创建静态群组">创建静态群组</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span  @click="createIntelligentGroup" style="margin-left: 0" >创建动态群组</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
        <!--群组列表-->
        <el-table v-if="showCustomer === true" key="tableData" id="tableData" ref="multipleTable" :data="tableData" v-loading="loading" @selection-change="handleSelectionChange" class="table-checkbox-style">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="群组名称">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.name }}</p>
                <div slot="reference" class="name-wrapper" style="color:#606266">
                  <router-link :to="{ name: 'groupManageDetil', query: { id: scope.row.id, type: scope.row.type }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                    {{ scope.row.name }}
                  </router-link>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="" label="客户人数">
            <template slot-scope="scope">
              <span v-if="scope.row.number === -1">正在统计中</span>
              <span v-if="scope.row.number !== -1">{{ scope.row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ groupsType[scope.row.type] }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间" min-width="115">
            <template slot-scope="scope">
              {{ scope.row.update_time | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="115">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <!--<div class="op-link" @click="edit(scope.row)">-->
                <!--<i class="iconfont icon-icon-bianji" style="font-size: 14px"></i>-->
                <!--<span>编辑</span>-->
              <!--</div>-->
              <router-link :to="{ name: 'groupManageDetil', query: { id: scope.row.id, type: scope.row.type }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                查看
              </router-link>
              <div class="op-link" @click="deleteItem(scope.row)">
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--客户列表-->
        <el-table v-if="showCustomer === false" key="customerData" id="customerData" ref="customerData" :data="customerData" class="list-style table">
          <!-- <el-table-column label="头像" width="70">
            <template slot-scope="scope">
            </template>
          </el-table-column> -->
          <el-table-column prop="realname" label="客户" width="">
            <template slot-scope="scope">
              <img :src="scope.row.avatar | showImgUrl" alt="" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%;float:left;margin-right:10px;">
              <span v-if="scope.row.realname !== ''" style="line-height: 32px;">{{ scope.row.realname }}</span>
              <span v-if="scope.row.realname === '' && scope.row.nickname !== ''" style="line-height: 32px;">{{ scope.row.nickname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.join_date === 0">{{ scope.row.create_time | formatDate }}</span>
              <span v-else>{{ scope.row.join_date | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="source_name" label="初始来源内容" width=""></el-table-column>
          <el-table-column label="城市" width="">
            <template slot-scope="scope">
              {{ scope.row.province_name }}{{ scope.row.city_name }}{{ scope.row.district_name }}
            </template>
          </el-table-column>
          <el-table-column label="当前等级" width="">
            <template slot-scope="scope">
              <span v-if="!scope.row.stage_name">未知</span>
              <span>{{ scope.row.stage_name }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot" style="text-align: right">
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>

    <!--添加群组分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建群组分组" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules">
        <el-form-item label="分组名称:" prop="name" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入群组分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑群组分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑群组分组" :visible.sync="editdialog" width="520px">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules">
        <el-form-item label="分组名称:" prop="name" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="editForm.name" auto-complete="off" placeholder="输入群组分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGroupTypeList, addGroupType, deleteGroupType, getGroupList, editGroupType, deleteGroup, addGroup, confirmChooseGroupType, getCustomerList } from '@/api/customer.js'
import HigherSearch from './../common/higher-search.vue'
export default {
  name: 'groupManage',
  data () {
    return {
      editFormRules: {
        name: [
          { required: true, message: '分组名字不能为空', trigger: 'change' }
        ]
      },
      addFormRules: {
        name: [
          { required: true, message: '分组名字不能为空', trigger: 'change' }
        ]
      },
      loading: true,
      group_id: '',
      queryGroups: [],
      tableData: [],
      customerData: [],
      showCustomer: true,
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      search: {
        name: '',
        group_id: ''
      },
      groupNameTmp: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      groupsType: {
        1: '动态群组',
        2: '静态群组'
      },
      isHigher: false,
      createGroupType: 0,
      groupTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      result: [],
      len: 0
    }
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function(item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
    'higher-search': HigherSearch
  },
  methods: {
    searchLoad() {
      this.groupName = JSON.parse(JSON.stringify(this.groupNameTmp))
      this.page = 1
      this.load()
    },
    // 刷新人数状态
    reloadCustomerNum() {
      this.load()
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    // 添加群组
    saveQuery() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      if (this.allTerms.termsGroup.length === 1) {
        console.log('sssss', this.allTerms)
        if (this.allTerms.termsGroup[0].terms[0].value == null && this.allTerms.allRelationship !== 'and') {
          _g.toastMsg('error', '请选择条件')
          return
        }
      }
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      // 防止重复点击
      this.isDisabled = true
      addGroup(this.newGroupName, this.createGroupType, termsSend).then((res) => {
        if (res.data.code === 0) {
          this.isDisabled = false
          this.isHigher = false
          this.newGroupName = ''
          this.showCustomer = true
          this.newGroupName = ''
          this.customerData = []
          this.load()
          _g.toastMsg('success', res.data.error)
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 查找群组类型
    searchGroupType() {
      let _this = this
      if (this.groupNameTmp === '') {
        return
      }
      let tmpNewitems = []
      this.groups.map(function(item) {
        if (item.name.search(_this.groupNameTmp) != -1) {
          tmpNewitems.push(item)
        }
      })
      let flag = 0
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in tmpNewitems) {
          if (this.groups[i].id === tmpNewitems[j].id) {
            this.groups[i].choosen = true
            flag++
          }
        }
      }
      if (flag === 0) {
        _g.toastMsg('error', '没有查询到分组')
      }
    },
    // 预览
    preView() {
      // 判断是否为空
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断客户属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].start_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].end_time === '') {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户事件是否为空
          if (item.terms[j].attr === 'event') {
            // 需要选内容的
            //              if (
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
            //                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
            //              ) {
            //                if (item.terms[j].value === '') {
            //                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
            //                  return
            //                }
            //              }
            // 如果是微信回复
            if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
              if (item.terms[j].value === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                return
              }
              if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                return
              }
            }
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              console.log('102')
              if (item.terms[j].selectedOptions[1] !== 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                }
              }
              if (item.terms[j].selectedOptions[1] === 'order') {
                for (let yi of item.terms[j].eventAttrOptions) {
                  if (yi.attributeContent.length === 0) {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                    return
                  }
                  if (yi.attributeRelation === '') {
                    _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                    return
                  }
                  if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                    if (yi.attributeValue === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                      return
                    }
                  }
                  if (yi.attributeRelation === 'gtele') {
                    if (yi.attrValTimeStart === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                      return
                    }
                    if (yi.attrValTimeEnd === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                      return
                    }
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断客户身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关客户关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].minKpiValue === 'undefined' || typeof item.terms[j].maxKpiValue === 'undefined' || item.terms[j].minKpiValue === '' || item.terms[j].maxKpiValue === null || item.terms[j].maxKpiValue === '' || item.terms[j].minKpiValue === null) {
                  _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      this.showCustomer = false
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      getCustomerList(1, 0, termsSend).then((res) => {
        if (res.data.code === 0) {
          this.page = 1
          let data = res.data.data.list
          this.result = []
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.customerData = this.result[0]
          this.totalCount = res.data.data.count
        }
      })
    },
    // 点选群组类型
    chooseGroupType(index, item) {
      this.groupTypeIndex = index
      this.search.group_id = item.id
      this.load()
    },
    // 取消创建群组
    cancelCreate() {
      this.isHigher = false
      this.createGroupType = 0
      this.page = 1
      this.showCustomer = true
      this.newGroupName = ''
      this.customerData = []
      this.load()
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
    },
    // 确认移到分组
    confirmChooseGroupType() {
      confirmChooseGroupType(this.group_id, this.deleteArrayIds).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '移动群组成功')
          this.group_id = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange(val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    },
    // 列表删除
    deleteItem(item) {
      this.$confirm('确认删除该群组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGroup(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除群组成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      if (this.showCustomer === false) {
        this.lastId = this.customerData[this.customerData.length - 1].id
        this.preView()
      } else {
        this.load()
      }
    },
    handleCurrentChange(page) {
      this.page = page
      if (this.showCustomer === false) {
        this.customerData = this.result[page - 1]
        this.lastId = this.customerData[this.customerData.length - 1].id
        if (this.lastId === this.result[this.result.length - 1][9].id) {
          let termsSend = JSON.parse(JSON.stringify(this.allTerms))
          for (let item of termsSend.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          getCustomerList(this.page, this.lastId, termsSend).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.customerData = this.result[page - 1]
              this.totalCount = res.data.data.count
            }
          })
        }
      } else {
        this.load()
      }
    },
    // 加载群组列表
    load() {
      this.loading = true
      getGroupList(this.page, this.search, this.limit).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.count
          this.len = res.data.data.count
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 创建静态群组（显示高级查询弹窗）
    createStaticsGroup() {
      this.isHigher = true
      this.createGroupType = 2
      this.page = 1
      this.search.name = ''
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
    },
    // 创建智能群组（显示高级查询弹窗）
    createIntelligentGroup() {
      this.isHigher = true
      this.createGroupType = 1
      this.page = 1
      this.search.name = ''
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
    },
    // 添加群组分组
    addGroup() {
      this.adddialog = true
      this.addForm.name = ''
    },
    // 请求群组类型数组
    loadGroupType() {
      getGroupTypeList().then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({ id: '', name: '全部' })
          for (let item of res.data.data.list) {
            item.choosen = false
          }
          this.groups = res.data.data.list
        }
      })
    },
    // 请求群组类型数组(给select用)
    loadGroupTypes() {
      getGroupTypeList().then((res) => {
        if (res.data.code === 0) {
          this.queryGroups = res.data.data.list
        }
      })
    },
    // 左侧分组导航
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 删除群组分组
    deleteGroupTypeItem(item) {
      this.$confirm('确认删除该群组分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGroupType(item.id).then((res) => {
          if (res.data.code === 0) {
            this.loadGroupType()
            _g.toastMsg('success', '删除群组分组成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑群组分组
    editGroupTypeItem(item) {
      this.editdialog = true
      this.editForm.name = item.name
      this.editGroupTypeId = item.id
    },
    confirmEdit() {
      editGroupType(this.editForm.name, this.editGroupTypeId).then((res) => {
        if (res.data.code === 0) {
          this.loadGroupType()
          _g.toastMsg('success', '编辑群组分组成功')
          this.editdialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 创建群组分组弹窗确定
    confirmAdd() {
      addGroupType(this.addForm.name).then((res) => {
        if (res.data.code === 0) {
          this.loadGroupType()
          _g.toastMsg('success', '添加群组分组成功')
          this.adddialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 关闭群组分组弹窗
    cancelAdd() {
      this.adddialog = false
    }
  },
  created() {
    this.load()
    this.loadGroupType()
    this.loadGroupTypes()
  }
}
</script>

<style scoped>
.name-wrapper{
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
  cursor: pointer;
}
@media only screen and (max-width: 1450px) {
   .text-align-right .fold-button-content {
      display: none;
   }
   .text-align-right .dropdown-btn-content {
      display: inline-block;
   }
  }
  .fold-button-content {
      float: right;
      display: inline-block;
   }
   .dropdown-btn-content {
      display: none;
   }
  .el-menu-item .menu-btn{display:none;float:right;}
  .el-menu-item:hover .menu-btn{display: block}
  .disabled{
    background: #ccc!important;
  }
  .getIt{
    color: #FF5500!important;
  }
  .cancelCreate{
    float: right;
    margin-right: 10px;
    color: #ff7373;
    cursor: pointer;
  }
  .el-menu-vertical-demo{
    position: relative;
  }
  .group-search{
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #e5e5e5;
  }
  .el-radio-group{
    margin-top: -13px;
  }
  .text-align-left{
    text-align: left;
  }
  .text-align-right{
    text-align: right;
  }
  .table-title{
    text-align: left;
  }
/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
  ::-webkit-scrollbar
  {
    width: 6px;  /*滚动条宽度*/
    height: 16px;  /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;  /*滚动条的背景区域的圆角*/
    background-color: #f5f5f5;/*滚动条的背景颜色*/
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;  /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #ccc;  /*滚动条的背景颜色*/
  }
  .el-dropdown-link {
    display: inline-block;
    background-color: #1890FF;
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 92px;
    border-radius: 20px;
    color: #fff;
    outline: none;
    margin-right: 10px;
    cursor: pointer;
  }
</style>
